import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { UserOwnedRequests } from '../../models/api/simple-request-information-model';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(private http: HttpClient) { }

  async deleteUserAndSetNewOwner(userId: string) {
    return this.http.delete(`${environment.apiUrl}/fe-api/user/${userId}`);
  }

  getUserRequests(userId: string): Observable<UserOwnedRequests> {
    return this.http.get<UserOwnedRequests>(`${environment.apiUrl}/fe-api/user/${userId}/requests`);
  }
}
